var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 1.6665C10.7171 1.6665 9.6665 2.7171 9.6665 3.99984C9.6665 4.19509 9.73269 4.36966 9.77848 4.55127L5.78174 6.55062C5.35288 6.02448 4.72701 5.6665 3.99984 5.6665C2.71709 5.6665 1.6665 6.7171 1.6665 7.99984C1.6665 9.28258 2.71709 10.3332 3.99984 10.3332C4.72701 10.3332 5.35288 9.97519 5.78174 9.44906L9.77848 11.4484C9.73269 11.63 9.6665 11.8046 9.6665 11.9998C9.6665 13.2826 10.7171 14.3332 11.9998 14.3332C13.2826 14.3332 14.3332 13.2826 14.3332 11.9998C14.3332 10.7171 13.2826 9.6665 11.9998 9.6665C11.2727 9.6665 10.6468 10.0245 10.2179 10.5506L6.22119 8.55127C6.26699 8.36966 6.33317 8.19509 6.33317 7.99984C6.33317 7.80458 6.26699 7.63002 6.22119 7.44841L10.2179 5.44906C10.6468 5.97519 11.2727 6.33317 11.9998 6.33317C13.2826 6.33317 14.3332 5.28258 14.3332 3.99984C14.3332 2.7171 13.2826 1.6665 11.9998 1.6665ZM11.9998 2.6665C12.7421 2.6665 13.3332 3.25753 13.3332 3.99984C13.3332 4.74214 12.7421 5.33317 11.9998 5.33317C11.2575 5.33317 10.6665 4.74214 10.6665 3.99984C10.6665 3.25753 11.2575 2.6665 11.9998 2.6665ZM3.99984 6.6665C4.74214 6.6665 5.33317 7.25753 5.33317 7.99984C5.33317 8.74214 4.74214 9.33317 3.99984 9.33317C3.25753 9.33317 2.6665 8.74214 2.6665 7.99984C2.6665 7.25753 3.25753 6.6665 3.99984 6.6665ZM11.9998 10.6665C12.7421 10.6665 13.3332 11.2575 13.3332 11.9998C13.3332 12.7421 12.7421 13.3332 11.9998 13.3332C11.2575 13.3332 10.6665 12.7421 10.6665 11.9998C10.6665 11.2575 11.2575 10.6665 11.9998 10.6665Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.06b0426a438700df30c63b58d1ea18df.svg";
export { ForwardRef as ReactComponent };